import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, exec } = useRequest({
    name: 'GET_PROCESS_ACTION_LIST',
    url: '/api/system/processesaction',
    manual: false,
  });
  return [data || [], exec];
});
